/**
 * SignalCard - Displays the signal event
 */
import React from 'react';
import { motion } from 'framer-motion';

const SignalCard = ({ signal }) => {
  const districtIcons = {
    income: '💰',
    stability: '🏛️',
    regulation: '⚖️',
    risk: '⚡',
    knowledge: '📚',
    growth: '📈'
  };

  const icon = districtIcons[signal.district] || '📢';
  const districtLabel = signal.district?.replace('_', ' ') || 'unknown';

  return (
    <motion.div
      className="border border-hairline bg-bone-raised rounded-lg p-6"
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-start gap-4">
        <div className="text-4xl" aria-hidden="true">
          {icon}
        </div>
        <div className="flex-1">
          <div className="text-label text-secondary mb-2 uppercase tracking-wide">
            Signal from {districtLabel} District
          </div>
          <div className="text-body text-primary leading-relaxed whitespace-pre-line">
            {signal.signal_text}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SignalCard;
